(() => {
  var e,
    t,
    n,
    i,
    o,
    a = Object.create,
    r = Object.defineProperty,
    l = Object.getOwnPropertyDescriptor,
    s = Object.getOwnPropertyNames,
    u = Object.getPrototypeOf,
    c = Object.prototype.hasOwnProperty,
    d =
      ((n = ((e = {
        "node_modules/photoswipe/dist/photoswipe.js"(e, t) {
          var n, i;
          (n = e),
            (i = function () {
              return function (e, t, n, i) {
                var o = {
                  features: null,
                  bind: function (e, t, n, i) {
                    var o = (i ? "remove" : "add") + "EventListener";
                    t = t.split(" ");
                    for (var a = 0; a < t.length; a++)
                      t[a] && e[o](t[a], n, !1);
                  },
                  isArray: function (e) {
                    return e instanceof Array;
                  },
                  createEl: function (e, t) {
                    var n = document.createElement(t || "div");
                    return e && (n.className = e), n;
                  },
                  getScrollY: function () {
                    var e = window.pageYOffset;
                    return void 0 !== e
                      ? e
                      : document.documentElement.scrollTop;
                  },
                  unbind: function (e, t, n) {
                    o.bind(e, t, n, !0);
                  },
                  removeClass: function (e, t) {
                    var n = RegExp("(\\s|^)" + t + "(\\s|$)");
                    e.className = e.className
                      .replace(n, " ")
                      .replace(/^\s\s*/, "")
                      .replace(/\s\s*$/, "");
                  },
                  addClass: function (e, t) {
                    o.hasClass(e, t) ||
                      (e.className += (e.className ? " " : "") + t);
                  },
                  hasClass: function (e, t) {
                    return (
                      e.className &&
                      RegExp("(^|\\s)" + t + "(\\s|$)").test(e.className)
                    );
                  },
                  getChildByClass: function (e, t) {
                    for (var n = e.firstChild; n; ) {
                      if (o.hasClass(n, t)) return n;
                      n = n.nextSibling;
                    }
                  },
                  arraySearch: function (e, t, n) {
                    for (var i = e.length; i--; ) if (e[i][n] === t) return i;
                    return -1;
                  },
                  extend: function (e, t, n) {
                    for (var i in t)
                      if (t.hasOwnProperty(i)) {
                        if (n && e.hasOwnProperty(i)) continue;
                        e[i] = t[i];
                      }
                  },
                  easing: {
                    sine: {
                      out: function (e) {
                        return Math.sin(e * (Math.PI / 2));
                      },
                      inOut: function (e) {
                        return -(Math.cos(Math.PI * e) - 1) / 2;
                      },
                    },
                    cubic: {
                      out: function (e) {
                        return --e * e * e + 1;
                      },
                    },
                  },
                  detectFeatures: function () {
                    if (o.features) return o.features;
                    var e = o.createEl().style,
                      t = "",
                      n = {};
                    if (
                      ((n.oldIE = document.all && !document.addEventListener),
                      (n.touch = "ontouchstart" in window),
                      window.requestAnimationFrame &&
                        ((n.raf = window.requestAnimationFrame),
                        (n.caf = window.cancelAnimationFrame)),
                      (n.pointerEvent =
                        !!window.PointerEvent || navigator.msPointerEnabled),
                      !n.pointerEvent)
                    ) {
                      var i = navigator.userAgent;
                      if (/iP(hone|od)/.test(navigator.platform)) {
                        var a = navigator.appVersion.match(
                          /OS (\d+)_(\d+)_?(\d+)?/
                        );
                        a &&
                          a.length > 0 &&
                          (a = parseInt(a[1], 10)) >= 1 &&
                          a < 8 &&
                          (n.isOldIOSPhone = !0);
                      }
                      var r = i.match(/Android\s([0-9\.]*)/),
                        l = r ? r[1] : 0;
                      (l = parseFloat(l)) >= 1 &&
                        (l < 4.4 && (n.isOldAndroid = !0),
                        (n.androidVersion = l)),
                        (n.isMobileOpera = /opera mini|opera mobi/i.test(i));
                    }
                    for (
                      var s,
                        u,
                        c = ["transform", "perspective", "animationName"],
                        d = ["", "webkit", "Moz", "ms", "O"],
                        p = 0;
                      p < 4;
                      p++
                    ) {
                      t = d[p];
                      for (var f = 0; f < 3; f++)
                        (s = c[f]),
                          (u =
                            t +
                            (t ? s.charAt(0).toUpperCase() + s.slice(1) : s)),
                          !n[s] && u in e && (n[s] = u);
                      t &&
                        !n.raf &&
                        ((t = t.toLowerCase()),
                        (n.raf = window[t + "RequestAnimationFrame"]),
                        n.raf &&
                          (n.caf =
                            window[t + "CancelAnimationFrame"] ||
                            window[t + "CancelRequestAnimationFrame"]));
                    }
                    if (!n.raf) {
                      var m = 0;
                      (n.raf = function (e) {
                        var t = new Date().getTime(),
                          n = Math.max(0, 16 - (t - m)),
                          i = window.setTimeout(function () {
                            e(t + n);
                          }, n);
                        return (m = t + n), i;
                      }),
                        (n.caf = function (e) {
                          clearTimeout(e);
                        });
                    }
                    return (
                      (n.svg =
                        !!document.createElementNS &&
                        !!document.createElementNS(
                          "http://www.w3.org/2000/svg",
                          "svg"
                        ).createSVGRect),
                      (o.features = n),
                      n
                    );
                  },
                };
                o.detectFeatures(),
                  o.features.oldIE &&
                    (o.bind = function (e, t, n, i) {
                      t = t.split(" ");
                      for (
                        var o,
                          a = (i ? "detach" : "attach") + "Event",
                          r = function () {
                            n.handleEvent.call(n);
                          },
                          l = 0;
                        l < t.length;
                        l++
                      )
                        if ((o = t[l])) {
                          if ("object" == typeof n && n.handleEvent) {
                            if (i) {
                              if (!n["oldIE" + o]) return !1;
                            } else n["oldIE" + o] = r;
                            e[a]("on" + o, n["oldIE" + o]);
                          } else e[a]("on" + o, n);
                        }
                    });
                var a = this,
                  r = {
                    allowPanToNext: !0,
                    spacing: 0.12,
                    bgOpacity: 1,
                    mouseUsed: !1,
                    loop: !0,
                    pinchToClose: !0,
                    closeOnScroll: !0,
                    closeOnVerticalDrag: !0,
                    verticalDragRange: 0.75,
                    hideAnimationDuration: 333,
                    showAnimationDuration: 333,
                    showHideOpacity: !1,
                    focus: !0,
                    escKey: !0,
                    arrowKeys: !0,
                    mainScrollEndFriction: 0.35,
                    panEndFriction: 0.35,
                    isClickableElement: function (e) {
                      return "A" === e.tagName;
                    },
                    getDoubleTapZoom: function (e, t) {
                      return e || t.initialZoomLevel < 0.7 ? 1 : 1.33;
                    },
                    maxSpreadZoom: 1.33,
                    modal: !0,
                    scaleMode: "fit",
                  };
                o.extend(r, i);
                var l,
                  s,
                  u,
                  c,
                  d,
                  p,
                  f,
                  m,
                  $,
                  y,
                  x,
                  h,
                  v,
                  g,
                  _,
                  b,
                  w,
                  C,
                  I,
                  D,
                  S,
                  O,
                  A,
                  E,
                  k,
                  P,
                  R,
                  T,
                  Z,
                  L,
                  F,
                  z,
                  M,
                  N,
                  U,
                  H,
                  Y,
                  W,
                  B,
                  G,
                  X,
                  V,
                  K,
                  q,
                  j,
                  J,
                  Q,
                  ee,
                  et,
                  en,
                  ei,
                  eo,
                  ea,
                  er,
                  el,
                  es,
                  eu = { x: 0, y: 0 },
                  ec = { x: 0, y: 0 },
                  ed = { x: 0, y: 0 },
                  ep = {},
                  ef = 0,
                  em = {},
                  e$ = { x: 0, y: 0 },
                  ey = 0,
                  ex = !0,
                  eh = [],
                  ev = {},
                  eg = !1,
                  e_ = function (e, t) {
                    o.extend(a, t.publicMethods), eh.push(e);
                  },
                  eb = function (e) {
                    var t = tE();
                    return e > t - 1 ? e - t : e < 0 ? t + e : e;
                  },
                  ew = {},
                  eC = function (e, t) {
                    return ew[e] || (ew[e] = []), ew[e].push(t);
                  },
                  eI = function (e) {
                    var t = ew[e];
                    if (t) {
                      var n = Array.prototype.slice.call(arguments);
                      n.shift();
                      for (var i = 0; i < t.length; i++) t[i].apply(a, n);
                    }
                  },
                  eD = function () {
                    return new Date().getTime();
                  },
                  eS = function (e) {
                    (er = e), (a.bg.style.opacity = e * r.bgOpacity);
                  },
                  eO = function (e, t, n, i, o) {
                    (!eg || (o && o !== a.currItem)) &&
                      (i /= o ? o.fitRatio : a.currItem.fitRatio),
                      (e[O] =
                        h + t + "px, " + n + "px" + v + " scale(" + i + ")");
                  },
                  eA = function (e) {
                    et &&
                      (e &&
                        (y > a.currItem.fitRatio
                          ? eg || (t8(a.currItem, !1, !0), (eg = !0))
                          : eg && (t8(a.currItem), (eg = !1))),
                      eO(et, ed.x, ed.y, y));
                  },
                  eE = function (e) {
                    e.container &&
                      eO(
                        e.container.style,
                        e.initialPosition.x,
                        e.initialPosition.y,
                        e.initialZoomLevel,
                        e
                      );
                  },
                  ek = function (e, t) {
                    t[O] = h + e + "px, 0px" + v;
                  },
                  eP = function (e, t) {
                    if (!r.loop && t) {
                      var n = c + (e$.x * ef - e) / e$.x,
                        i = Math.round(e - eQ.x);
                      ((n < 0 && i > 0) || (n >= tE() - 1 && i < 0)) &&
                        (e = eQ.x + i * r.mainScrollEndFriction);
                    }
                    (eQ.x = e), ek(e, d);
                  },
                  eR = function (e, t) {
                    var n = te[e] - em[e];
                    return ec[e] + eu[e] + n - n * (t / x);
                  },
                  eT = function (e, t) {
                    (e.x = t.x), (e.y = t.y), t.id && (e.id = t.id);
                  },
                  eZ = function (e) {
                    (e.x = Math.round(e.x)), (e.y = Math.round(e.y));
                  },
                  eL = null,
                  eF = function () {
                    eL &&
                      (o.unbind(document, "mousemove", eF),
                      o.addClass(e, "pswp--has_mouse"),
                      (r.mouseUsed = !0),
                      eI("mouseUsed")),
                      (eL = setTimeout(function () {
                        eL = null;
                      }, 100));
                  },
                  e1 = function (e, t) {
                    var n = tZ(a.currItem, ep, e);
                    return t && (ee = n), n;
                  },
                  e8 = function (e) {
                    return e || (e = a.currItem), e.initialZoomLevel;
                  },
                  e0 = function (e) {
                    return e || (e = a.currItem), e.w > 0 ? r.maxSpreadZoom : 1;
                  },
                  ez = function (e, t, n, i) {
                    return i === a.currItem.initialZoomLevel
                      ? ((n[e] = a.currItem.initialPosition[e]), !0)
                      : ((n[e] = eR(e, i)),
                        n[e] > t.min[e]
                          ? ((n[e] = t.min[e]), !0)
                          : n[e] < t.max[e] && ((n[e] = t.max[e]), !0));
                  },
                  eM = function (e) {
                    var t = "";
                    r.escKey && 27 === e.keyCode
                      ? (t = "close")
                      : r.arrowKeys &&
                        (37 === e.keyCode
                          ? (t = "prev")
                          : 39 === e.keyCode && (t = "next")),
                      t &&
                        (e.ctrlKey ||
                          e.altKey ||
                          e.shiftKey ||
                          e.metaKey ||
                          (e.preventDefault
                            ? e.preventDefault()
                            : (e.returnValue = !1),
                          a[t]()));
                  },
                  eN = function (e) {
                    e &&
                      (V || X || en || Y) &&
                      (e.preventDefault(), e.stopPropagation());
                  },
                  eU = function () {
                    a.setScrollOffset(0, o.getScrollY());
                  },
                  e3 = {},
                  eH = 0,
                  eY = function (e) {
                    e3[e] && (e3[e].raf && P(e3[e].raf), eH--, delete e3[e]);
                  },
                  eW = function (e) {
                    e3[e] && eY(e), e3[e] || (eH++, (e3[e] = {}));
                  },
                  eB = function () {
                    for (var e in e3) e3.hasOwnProperty(e) && eY(e);
                  },
                  eG = function (e, t, n, i, o, a, r) {
                    var l,
                      s = eD();
                    eW(e);
                    var u = function () {
                      if (e3[e]) {
                        if ((l = eD() - s) >= i)
                          return eY(e), a(n), void (r && r());
                        a((n - t) * o(l / i) + t), (e3[e].raf = k(u));
                      }
                    };
                    u();
                  },
                  eX = {},
                  eV = {},
                  eK = {},
                  e4 = {},
                  e2 = {},
                  eq = [],
                  e5 = {},
                  ej = [],
                  e6 = {},
                  e7 = 0,
                  e9 = { x: 0, y: 0 },
                  eJ = 0,
                  eQ = { x: 0, y: 0 },
                  te = { x: 0, y: 0 },
                  tt = { x: 0, y: 0 },
                  tn = function (e, t) {
                    return (
                      (e6.x = Math.abs(e.x - t.x)),
                      (e6.y = Math.abs(e.y - t.y)),
                      Math.sqrt(e6.x * e6.x + e6.y * e6.y)
                    );
                  },
                  ti = function () {
                    K && (P(K), (K = null));
                  },
                  to = function () {
                    B && ((K = k(to)), th());
                  },
                  ta = function (e, t) {
                    return (
                      !(!e || e === document) &&
                      !(
                        e.getAttribute("class") &&
                        e.getAttribute("class").indexOf("pswp__scroll-wrap") >
                          -1
                      ) &&
                      (t(e) ? e : ta(e.parentNode, t))
                    );
                  },
                  tr = {},
                  tl = function (e, t) {
                    return (
                      (tr.prevent = !ta(e.target, r.isClickableElement)),
                      eI("preventDragEvent", e, t, tr),
                      tr.prevent
                    );
                  },
                  ts = function (e, t) {
                    return (
                      (t.x = e.pageX), (t.y = e.pageY), (t.id = e.identifier), t
                    );
                  },
                  tu = function (e, t, n) {
                    (n.x = 0.5 * (e.x + t.x)), (n.y = 0.5 * (e.y + t.y));
                  },
                  tc = function () {
                    return (
                      1 -
                      Math.abs(
                        (ed.y - a.currItem.initialPosition.y) / (ep.y / 2)
                      )
                    );
                  },
                  td = {},
                  tp = {},
                  tf = [],
                  tm = function (e) {
                    for (; tf.length > 0; ) tf.pop();
                    return (
                      A
                        ? ((es = 0),
                          eq.forEach(function (e) {
                            0 === es ? (tf[0] = e) : 1 === es && (tf[1] = e),
                              es++;
                          }))
                        : e.type.indexOf("touch") > -1
                        ? e.touches &&
                          e.touches.length > 0 &&
                          ((tf[0] = ts(e.touches[0], td)),
                          e.touches.length > 1 &&
                            (tf[1] = ts(e.touches[1], tp)))
                        : ((td.x = e.pageX),
                          (td.y = e.pageY),
                          (td.id = ""),
                          (tf[0] = td)),
                      tf
                    );
                  },
                  t$ = function (e, t) {
                    var n,
                      i,
                      o,
                      l,
                      s = ed[e] + t[e],
                      u = t[e] > 0,
                      c = eQ.x + t.x,
                      d = eQ.x - e5.x;
                    if (
                      ((n =
                        s > ee.min[e] || s < ee.max[e] ? r.panEndFriction : 1),
                      (s = ed[e] + t[e] * n),
                      (r.allowPanToNext || y === a.currItem.initialZoomLevel) &&
                        (et
                          ? "h" !== ei ||
                            "x" !== e ||
                            X ||
                            (u
                              ? (s > ee.min[e] &&
                                  ((n = r.panEndFriction),
                                  ee.min[e],
                                  (i = ee.min[e] - ec[e])),
                                (i <= 0 || d < 0) && tE() > 1
                                  ? ((l = c), d < 0 && c > e5.x && (l = e5.x))
                                  : ee.min.x !== ee.max.x && (o = s))
                              : (s < ee.max[e] &&
                                  ((n = r.panEndFriction),
                                  ee.max[e],
                                  (i = ec[e] - ee.max[e])),
                                (i <= 0 || d > 0) && tE() > 1
                                  ? ((l = c), d > 0 && c < e5.x && (l = e5.x))
                                  : ee.min.x !== ee.max.x && (o = s)))
                          : (l = c),
                        "x" === e))
                    )
                      return (
                        void 0 !== l && (eP(l, !0), (q = l !== e5.x)),
                        ee.min.x !== ee.max.x &&
                          (void 0 !== o ? (ed.x = o) : q || (ed.x += t.x * n)),
                        void 0 !== l
                      );
                    en || q || (y > a.currItem.fitRatio && (ed[e] += t[e] * n));
                  },
                  ty = function (e) {
                    if (!("mousedown" === e.type && e.button > 0)) {
                      if (tO) e.preventDefault();
                      else if (!W || "mousedown" !== e.type) {
                        if (
                          (tl(e, !0) && e.preventDefault(),
                          eI("pointerDown"),
                          A)
                        ) {
                          var t = o.arraySearch(eq, e.pointerId, "id");
                          t < 0 && (t = eq.length),
                            (eq[t] = {
                              x: e.pageX,
                              y: e.pageY,
                              id: e.pointerId,
                            });
                        }
                        var n = tm(e),
                          i = n.length;
                        (j = null),
                          eB(),
                          (B && 1 !== i) ||
                            ((B = eo = !0),
                            o.bind(window, f, a),
                            (H = el = ea = Y = q = V = G = X = !1),
                            (ei = null),
                            eI("firstTouchStart", n),
                            eT(ec, ed),
                            (eu.x = eu.y = 0),
                            eT(e4, n[0]),
                            eT(e2, e4),
                            (e5.x = e$.x * ef),
                            (ej = [{ x: e4.x, y: e4.y }]),
                            (N = M = eD()),
                            e1(y, !0),
                            ti(),
                            to()),
                          J ||
                            !(i > 1) ||
                            en ||
                            q ||
                            ((x = y),
                            (X = !1),
                            (J = G = !0),
                            (eu.y = eu.x = 0),
                            eT(ec, ed),
                            eT(eX, n[0]),
                            eT(eV, n[1]),
                            tu(eX, eV, tt),
                            (te.x = Math.abs(tt.x) - ed.x),
                            (te.y = Math.abs(tt.y) - ed.y),
                            (Q = tn(eX, eV)));
                      }
                    }
                  },
                  tx = function (e) {
                    if ((e.preventDefault(), A)) {
                      var t = o.arraySearch(eq, e.pointerId, "id");
                      if (t > -1) {
                        var n = eq[t];
                        (n.x = e.pageX), (n.y = e.pageY);
                      }
                    }
                    if (B) {
                      var i = tm(e);
                      if (ei || V || J) j = i;
                      else if (eQ.x !== e$.x * ef) ei = "h";
                      else {
                        var a =
                          Math.abs(i[0].x - e4.x) - Math.abs(i[0].y - e4.y);
                        Math.abs(a) >= 10 &&
                          ((ei = a > 0 ? "h" : "v"), (j = i));
                      }
                    }
                  },
                  th = function () {
                    if (j) {
                      var e,
                        t,
                        n = j.length;
                      if (0 !== n) {
                        if (
                          (eT(eX, j[0]),
                          (eK.x = eX.x - e4.x),
                          (eK.y = eX.y - e4.y),
                          J && n > 1)
                        ) {
                          if (
                            ((e4.x = eX.x),
                            (e4.y = eX.y),
                            !eK.x &&
                              !eK.y &&
                              ((e = j[1]),
                              (t = eV),
                              e.x === t.x && e.y === t.y))
                          )
                            return;
                          eT(eV, j[1]),
                            X || ((X = !0), eI("zoomGestureStarted"));
                          var i = tn(eX, eV),
                            o = tw(i);
                          o >
                            a.currItem.initialZoomLevel +
                              a.currItem.initialZoomLevel / 15 && (el = !0);
                          var l = 1,
                            s = e8(),
                            u = e0();
                          if (o < s) {
                            if (
                              r.pinchToClose &&
                              !el &&
                              x <= a.currItem.initialZoomLevel
                            ) {
                              var c = 1 - (s - o) / (s / 1.2);
                              eS(c), eI("onPinchClose", c), (ea = !0);
                            } else
                              (l = (s - o) / s) > 1 && (l = 1),
                                (o = s - l * (s / 3));
                          } else
                            o > u &&
                              ((l = (o - u) / (6 * s)) > 1 && (l = 1),
                              (o = u + l * s));
                          l < 0 && (l = 0),
                            tu(eX, eV, e9),
                            (eu.x += e9.x - tt.x),
                            (eu.y += e9.y - tt.y),
                            eT(tt, e9),
                            (ed.x = eR("x", o)),
                            (ed.y = eR("y", o)),
                            (H = o > y),
                            (y = o),
                            eA();
                        } else {
                          if (
                            !ei ||
                            (eo &&
                              ((eo = !1),
                              Math.abs(eK.x) >= 10 && (eK.x -= j[0].x - e2.x),
                              Math.abs(eK.y) >= 10 && (eK.y -= j[0].y - e2.y)),
                            (e4.x = eX.x),
                            (e4.y = eX.y),
                            0 === eK.x && 0 === eK.y)
                          )
                            return;
                          if (
                            "v" === ei &&
                            r.closeOnVerticalDrag &&
                            "fit" === r.scaleMode &&
                            y === a.currItem.initialZoomLevel
                          ) {
                            (eu.y += eK.y), (ed.y += eK.y);
                            var d = tc();
                            return (
                              (Y = !0),
                              eI("onVerticalDrag", d),
                              eS(d),
                              void eA()
                            );
                          }
                          (function (e, t, n) {
                            if (e - N > 50) {
                              var i = ej.length > 2 ? ej.shift() : {};
                              (i.x = t), (i.y = n), ej.push(i), (N = e);
                            }
                          })(eD(), eX.x, eX.y),
                            (V = !0),
                            (ee = a.currItem.bounds),
                            t$("x", eK) || (t$("y", eK), eZ(ed), eA());
                        }
                      }
                    }
                  },
                  tv = function (e) {
                    if (F.isOldAndroid) {
                      if (W && "mouseup" === e.type) return;
                      e.type.indexOf("touch") > -1 &&
                        (clearTimeout(W),
                        (W = setTimeout(function () {
                          W = 0;
                        }, 600)));
                    }
                    if ((eI("pointerUp"), tl(e, !1) && e.preventDefault(), A)) {
                      var t = o.arraySearch(eq, e.pointerId, "id");
                      t > -1 &&
                        ((n = eq.splice(t, 1)[0]),
                        navigator.msPointerEnabled
                          ? ((n.type = { 4: "mouse", 2: "touch", 3: "pen" }[
                              e.pointerType
                            ]),
                            n.type || (n.type = e.pointerType || "mouse"))
                          : (n.type = e.pointerType || "mouse"));
                    }
                    var n,
                      i,
                      l = tm(e),
                      s = l.length;
                    if (("mouseup" === e.type && (s = 0), 2 === s))
                      return (j = null), !0;
                    1 === s && eT(e2, l[0]),
                      0 !== s ||
                        ei ||
                        en ||
                        (n ||
                          ("mouseup" === e.type
                            ? (n = { x: e.pageX, y: e.pageY, type: "mouse" })
                            : e.changedTouches &&
                              e.changedTouches[0] &&
                              (n = {
                                x: e.changedTouches[0].pageX,
                                y: e.changedTouches[0].pageY,
                                type: "touch",
                              })),
                        eI("touchRelease", e, n));
                    var u = -1;
                    if (
                      (0 === s &&
                        ((B = !1),
                        o.unbind(window, f, a),
                        ti(),
                        J ? (u = 0) : -1 !== eJ && (u = eD() - eJ)),
                      (eJ = 1 === s ? eD() : -1),
                      (i = -1 !== u && u < 150 ? "zoom" : "swipe"),
                      J &&
                        s < 2 &&
                        ((J = !1),
                        1 === s && (i = "zoomPointerUp"),
                        eI("zoomGestureEnded")),
                      (j = null),
                      V || X || en || Y)
                    ) {
                      if (
                        (eB(), U || (U = tg()), U.calculateSwipeSpeed("x"), Y)
                      ) {
                        if (tc() < r.verticalDragRange) a.close();
                        else {
                          var c = ed.y,
                            d = er;
                          eG(
                            "verticalDrag",
                            0,
                            1,
                            300,
                            o.easing.cubic.out,
                            function (e) {
                              (ed.y =
                                (a.currItem.initialPosition.y - c) * e + c),
                                eS((1 - d) * e + d),
                                eA();
                            }
                          ),
                            eI("onVerticalDrag", 1);
                        }
                      } else {
                        if ((q || en) && 0 === s) {
                          if (tb(i, U)) return;
                          i = "zoomPointerUp";
                        }
                        en ||
                          ("swipe" === i
                            ? !q && y > a.currItem.fitRatio && t_(U)
                            : tC());
                      }
                    }
                  },
                  tg = function () {
                    var e,
                      t,
                      n = {
                        lastFlickOffset: {},
                        lastFlickDist: {},
                        lastFlickSpeed: {},
                        slowDownRatio: {},
                        slowDownRatioReverse: {},
                        speedDecelerationRatio: {},
                        speedDecelerationRatioAbs: {},
                        distanceOffset: {},
                        backAnimDestination: {},
                        backAnimStarted: {},
                        calculateSwipeSpeed: function (i) {
                          ej.length > 1
                            ? ((e = eD() - N + 50), (t = ej[ej.length - 2][i]))
                            : ((e = eD() - M), (t = e2[i])),
                            (n.lastFlickOffset[i] = e4[i] - t),
                            (n.lastFlickDist[i] = Math.abs(
                              n.lastFlickOffset[i]
                            )),
                            n.lastFlickDist[i] > 20
                              ? (n.lastFlickSpeed[i] = n.lastFlickOffset[i] / e)
                              : (n.lastFlickSpeed[i] = 0),
                            0.1 > Math.abs(n.lastFlickSpeed[i]) &&
                              (n.lastFlickSpeed[i] = 0),
                            (n.slowDownRatio[i] = 0.95),
                            (n.slowDownRatioReverse[i] =
                              1 - n.slowDownRatio[i]),
                            (n.speedDecelerationRatio[i] = 1);
                        },
                        calculateOverBoundsAnimOffset: function (e, t) {
                          n.backAnimStarted[e] ||
                            (ed[e] > ee.min[e]
                              ? (n.backAnimDestination[e] = ee.min[e])
                              : ed[e] < ee.max[e] &&
                                (n.backAnimDestination[e] = ee.max[e]),
                            void 0 !== n.backAnimDestination[e] &&
                              ((n.slowDownRatio[e] = 0.7),
                              (n.slowDownRatioReverse[e] =
                                1 - n.slowDownRatio[e]),
                              n.speedDecelerationRatioAbs[e] < 0.05 &&
                                ((n.lastFlickSpeed[e] = 0),
                                (n.backAnimStarted[e] = !0),
                                eG(
                                  "bounceZoomPan" + e,
                                  ed[e],
                                  n.backAnimDestination[e],
                                  t || 300,
                                  o.easing.sine.out,
                                  function (t) {
                                    (ed[e] = t), eA();
                                  }
                                ))));
                        },
                        calculateAnimOffset: function (e) {
                          n.backAnimStarted[e] ||
                            ((n.speedDecelerationRatio[e] =
                              n.speedDecelerationRatio[e] *
                              (n.slowDownRatio[e] +
                                n.slowDownRatioReverse[e] -
                                (n.slowDownRatioReverse[e] * n.timeDiff) / 10)),
                            (n.speedDecelerationRatioAbs[e] = Math.abs(
                              n.lastFlickSpeed[e] * n.speedDecelerationRatio[e]
                            )),
                            (n.distanceOffset[e] =
                              n.lastFlickSpeed[e] *
                              n.speedDecelerationRatio[e] *
                              n.timeDiff),
                            (ed[e] += n.distanceOffset[e]));
                        },
                        panAnimLoop: function () {
                          if (
                            e3.zoomPan &&
                            ((e3.zoomPan.raf = k(n.panAnimLoop)),
                            (n.now = eD()),
                            (n.timeDiff = n.now - n.lastNow),
                            (n.lastNow = n.now),
                            n.calculateAnimOffset("x"),
                            n.calculateAnimOffset("y"),
                            eA(),
                            n.calculateOverBoundsAnimOffset("x"),
                            n.calculateOverBoundsAnimOffset("y"),
                            n.speedDecelerationRatioAbs.x < 0.05 &&
                              n.speedDecelerationRatioAbs.y < 0.05)
                          )
                            return (
                              (ed.x = Math.round(ed.x)),
                              (ed.y = Math.round(ed.y)),
                              eA(),
                              void eY("zoomPan")
                            );
                        },
                      };
                    return n;
                  },
                  t_ = function (e) {
                    if (
                      (e.calculateSwipeSpeed("y"),
                      (ee = a.currItem.bounds),
                      (e.backAnimDestination = {}),
                      (e.backAnimStarted = {}),
                      0.05 >= Math.abs(e.lastFlickSpeed.x) &&
                        0.05 >= Math.abs(e.lastFlickSpeed.y))
                    )
                      return (
                        (e.speedDecelerationRatioAbs.x =
                          e.speedDecelerationRatioAbs.y =
                            0),
                        e.calculateOverBoundsAnimOffset("x"),
                        e.calculateOverBoundsAnimOffset("y"),
                        !0
                      );
                    eW("zoomPan"), (e.lastNow = eD()), e.panAnimLoop();
                  },
                  tb = function (e, t) {
                    if ((en || (e7 = c), "swipe" === e)) {
                      var n = e4.x - e2.x,
                        i = t.lastFlickDist.x < 10;
                      n > 30 && (i || t.lastFlickOffset.x > 20)
                        ? (s = -1)
                        : n < -30 &&
                          (i || t.lastFlickOffset.x < -20) &&
                          (s = 1);
                    }
                    s &&
                      ((c += s) < 0
                        ? ((c = r.loop ? tE() - 1 : 0), (u = !0))
                        : c >= tE() && ((c = r.loop ? 0 : tE() - 1), (u = !0)),
                      (u && !r.loop) || ((ey += s), (ef -= s), (l = !0)));
                    var l,
                      s,
                      u,
                      d,
                      p = e$.x * ef,
                      f = Math.abs(p - eQ.x);
                    return (
                      (d =
                        l || p > eQ.x == t.lastFlickSpeed.x > 0
                          ? Math.max(
                              (d = Math.min(
                                (d =
                                  Math.abs(t.lastFlickSpeed.x) > 0
                                    ? f / Math.abs(t.lastFlickSpeed.x)
                                    : 333),
                                400
                              )),
                              250
                            )
                          : 333),
                      e7 === c && (l = !1),
                      (en = !0),
                      eI("mainScrollAnimStart"),
                      eG(
                        "mainScroll",
                        eQ.x,
                        p,
                        d,
                        o.easing.cubic.out,
                        eP,
                        function () {
                          eB(),
                            (en = !1),
                            (e7 = -1),
                            (l || e7 !== c) && a.updateCurrItem(),
                            eI("mainScrollAnimComplete");
                        }
                      ),
                      l && a.updateCurrItem(!0),
                      l
                    );
                  },
                  tw = function (e) {
                    return (1 / Q) * e * x;
                  },
                  tC = function () {
                    var e = y,
                      t = e8(),
                      n = e0();
                    y < t ? (e = t) : y > n && (e = n);
                    var i,
                      r = er;
                    return ea && !H && !el && y < t
                      ? (a.close(), !0)
                      : (ea &&
                          (i = function (e) {
                            eS((1 - r) * e + r);
                          }),
                        a.zoomTo(e, 0, 200, o.easing.cubic.out, i),
                        !0);
                  };
                e_("Gestures", {
                  publicMethods: {
                    initGestures: function () {
                      var e = function (e, t, n, i, o) {
                        (C = e + t),
                          (I = e + n),
                          (D = e + i),
                          (S = o ? e + o : "");
                      };
                      (A = F.pointerEvent) && F.touch && (F.touch = !1),
                        A
                          ? navigator.msPointerEnabled
                            ? e("MSPointer", "Down", "Move", "Up", "Cancel")
                            : e("pointer", "down", "move", "up", "cancel")
                          : F.touch
                          ? (e("touch", "start", "move", "end", "cancel"),
                            (E = !0))
                          : e("mouse", "down", "move", "up"),
                        (f = I + " " + D + " " + S),
                        (m = C),
                        A &&
                          !E &&
                          (E =
                            navigator.maxTouchPoints > 1 ||
                            navigator.msMaxTouchPoints > 1),
                        (a.likelyTouchDevice = E),
                        ($[C] = ty),
                        ($[I] = tx),
                        ($[D] = tv),
                        S && ($[S] = $[D]),
                        F.touch &&
                          ((m += " mousedown"),
                          (f += " mousemove mouseup"),
                          ($.mousedown = $[C]),
                          ($.mousemove = $[I]),
                          ($.mouseup = $[D])),
                        E || (r.allowPanToNext = !1);
                    },
                  },
                });
                var tI,
                  tD,
                  tS,
                  tO,
                  tA,
                  tE,
                  tk = function (t, n, i, l) {
                    tI && clearTimeout(tI),
                      (tO = !0),
                      (tS = !0),
                      t.initialLayout
                        ? ((s = t.initialLayout), (t.initialLayout = null))
                        : (s = r.getThumbBoundsFn && r.getThumbBoundsFn(c));
                    var s,
                      d,
                      p,
                      f = i ? r.hideAnimationDuration : r.showAnimationDuration,
                      m = function () {
                        eY("initialZoom"),
                          i
                            ? (a.template.removeAttribute("style"),
                              a.bg.removeAttribute("style"))
                            : (eS(1),
                              n && (n.style.display = "block"),
                              o.addClass(e, "pswp--animated-in"),
                              eI("initialZoom" + (i ? "OutEnd" : "InEnd"))),
                          l && l(),
                          (tO = !1);
                      };
                    if (!f || !s || void 0 === s.x)
                      return (
                        eI("initialZoom" + (i ? "Out" : "In")),
                        (y = t.initialZoomLevel),
                        eT(ed, t.initialPosition),
                        eA(),
                        (e.style.opacity = i ? 0 : 1),
                        eS(1),
                        void (f
                          ? setTimeout(function () {
                              m();
                            }, f)
                          : m())
                      );
                    (d = u),
                      (p =
                        !a.currItem.src ||
                        a.currItem.loadError ||
                        r.showHideOpacity),
                      t.miniImg &&
                        (t.miniImg.style.webkitBackfaceVisibility = "hidden"),
                      i ||
                        ((y = s.w / t.w),
                        (ed.x = s.x),
                        (ed.y = s.y - T),
                        (a[p ? "template" : "bg"].style.opacity = 0.001),
                        eA()),
                      eW("initialZoom"),
                      i && !d && o.removeClass(e, "pswp--animated-in"),
                      p &&
                        (i
                          ? o[(d ? "remove" : "add") + "Class"](
                              e,
                              "pswp--animate_opacity"
                            )
                          : setTimeout(function () {
                              o.addClass(e, "pswp--animate_opacity");
                            }, 30)),
                      (tI = setTimeout(
                        function () {
                          if ((eI("initialZoom" + (i ? "Out" : "In")), i)) {
                            var n = s.w / t.w,
                              a = { x: ed.x, y: ed.y },
                              r = y,
                              l = er,
                              u = function (t) {
                                1 === t
                                  ? ((y = n), (ed.x = s.x), (ed.y = s.y - L))
                                  : ((y = (n - r) * t + r),
                                    (ed.x = (s.x - a.x) * t + a.x),
                                    (ed.y = (s.y - L - a.y) * t + a.y)),
                                  eA(),
                                  p ? (e.style.opacity = 1 - t) : eS(l - t * l);
                              };
                            d
                              ? eG(
                                  "initialZoom",
                                  0,
                                  1,
                                  f,
                                  o.easing.cubic.out,
                                  u,
                                  m
                                )
                              : (u(1), (tI = setTimeout(m, f + 20)));
                          } else
                            (y = t.initialZoomLevel),
                              eT(ed, t.initialPosition),
                              eA(),
                              eS(1),
                              p ? (e.style.opacity = 1) : eS(1),
                              (tI = setTimeout(m, f + 20));
                        },
                        i ? 25 : 90
                      ));
                  },
                  tP = {},
                  tR = [],
                  tT = {
                    index: 0,
                    errorMsg:
                      '<div class="pswp__error-msg"><a href="%url%" target="_blank">The image</a> could not be loaded.</div>',
                    forceProgressiveLoading: !1,
                    preload: [1, 1],
                    getNumItemsFn: function () {
                      return tD.length;
                    },
                  },
                  tZ = function (e, t, n) {
                    if (e.src && !e.loadError) {
                      var i,
                        o,
                        a,
                        l,
                        s = !n;
                      if (
                        (s &&
                          (e.vGap || (e.vGap = { top: 0, bottom: 0 }),
                          eI("parseVerticalMargin", e)),
                        (tP.x = t.x),
                        (tP.y = t.y - e.vGap.top - e.vGap.bottom),
                        s)
                      ) {
                        var u = tP.x / e.w,
                          c = tP.y / e.h;
                        e.fitRatio = u < c ? u : c;
                        var d = r.scaleMode;
                        "orig" === d
                          ? (n = 1)
                          : "fit" === d && (n = e.fitRatio),
                          n > 1 && (n = 1),
                          (e.initialZoomLevel = n),
                          e.bounds ||
                            (e.bounds = {
                              center: { x: 0, y: 0 },
                              max: { x: 0, y: 0 },
                              min: { x: 0, y: 0 },
                            });
                      }
                      if (!n) return;
                      return (
                        (i = e),
                        (o = e.w * n),
                        (a = e.h * n),
                        ((l = i.bounds).center.x = Math.round((tP.x - o) / 2)),
                        (l.center.y = Math.round((tP.y - a) / 2) + i.vGap.top),
                        (l.max.x =
                          o > tP.x ? Math.round(tP.x - o) : l.center.x),
                        (l.max.y =
                          a > tP.y
                            ? Math.round(tP.y - a) + i.vGap.top
                            : l.center.y),
                        (l.min.x = o > tP.x ? 0 : l.center.x),
                        (l.min.y = a > tP.y ? i.vGap.top : l.center.y),
                        s &&
                          n === e.initialZoomLevel &&
                          (e.initialPosition = e.bounds.center),
                        e.bounds
                      );
                    }
                    return (
                      (e.w = e.h = 0),
                      (e.initialZoomLevel = e.fitRatio = 1),
                      (e.bounds = {
                        center: { x: 0, y: 0 },
                        max: { x: 0, y: 0 },
                        min: { x: 0, y: 0 },
                      }),
                      (e.initialPosition = e.bounds.center),
                      e.bounds
                    );
                  },
                  tL = function (e, t, n, i, o, r) {
                    t.loadError ||
                      (i &&
                        ((t.imageAppended = !0),
                        t8(t, i, t === a.currItem && eg),
                        n.appendChild(i),
                        r &&
                          setTimeout(function () {
                            t &&
                              t.loaded &&
                              t.placeholder &&
                              ((t.placeholder.style.display = "none"),
                              (t.placeholder = null));
                          }, 500)));
                  },
                  tF = function (e) {
                    (e.loading = !0), (e.loaded = !1);
                    var t = (e.img = o.createEl("pswp__img", "img")),
                      n = function () {
                        (e.loading = !1),
                          (e.loaded = !0),
                          e.loadComplete ? e.loadComplete(e) : (e.img = null),
                          (t.onload = t.onerror = null),
                          (t = null);
                      };
                    return (
                      (t.onload = n),
                      (t.onerror = function () {
                        (e.loadError = !0), n();
                      }),
                      (t.src = e.src),
                      t
                    );
                  },
                  t1 = function (e, t) {
                    if (e.src && e.loadError && e.container)
                      return (
                        t && (e.container.innerHTML = ""),
                        (e.container.innerHTML = r.errorMsg.replace(
                          "%url%",
                          e.src
                        )),
                        !0
                      );
                  },
                  t8 = function (e, t, n) {
                    if (e.src) {
                      t || (t = e.container.lastChild);
                      var i = n ? e.w : Math.round(e.w * e.fitRatio),
                        o = n ? e.h : Math.round(e.h * e.fitRatio);
                      e.placeholder &&
                        !e.loaded &&
                        ((e.placeholder.style.width = i + "px"),
                        (e.placeholder.style.height = o + "px")),
                        (t.style.width = i + "px"),
                        (t.style.height = o + "px");
                    }
                  },
                  t0 = function () {
                    if (tR.length) {
                      for (var e, t = 0; t < tR.length; t++)
                        (e = tR[t]).holder.index === e.index &&
                          tL(
                            e.index,
                            e.item,
                            e.baseDiv,
                            e.img,
                            0,
                            e.clearPlaceholder
                          );
                      tR = [];
                    }
                  };
                e_("Controller", {
                  publicMethods: {
                    lazyLoadItem: function (e) {
                      e = eb(e);
                      var t = tA(e);
                      t &&
                        ((!t.loaded && !t.loading) || _) &&
                        (eI("gettingData", e, t), t.src && tF(t));
                    },
                    initController: function () {
                      o.extend(r, tT, !0),
                        (a.items = tD = n),
                        (tA = a.getItemAt),
                        (tE = r.getNumItemsFn),
                        r.loop,
                        3 > tE() && (r.loop = !1),
                        eC("beforeChange", function (e) {
                          var t,
                            n = r.preload,
                            i = null === e || e >= 0,
                            o = Math.min(n[0], tE()),
                            l = Math.min(n[1], tE());
                          for (t = 1; t <= (i ? l : o); t++)
                            a.lazyLoadItem(c + t);
                          for (t = 1; t <= (i ? o : l); t++)
                            a.lazyLoadItem(c - t);
                        }),
                        eC("initialLayout", function () {
                          a.currItem.initialLayout =
                            r.getThumbBoundsFn && r.getThumbBoundsFn(c);
                        }),
                        eC("mainScrollAnimComplete", t0),
                        eC("initialZoomInEnd", t0),
                        eC("destroy", function () {
                          for (var e, t = 0; t < tD.length; t++)
                            (e = tD[t]).container && (e.container = null),
                              e.placeholder && (e.placeholder = null),
                              e.img && (e.img = null),
                              e.preloader && (e.preloader = null),
                              e.loadError && (e.loaded = e.loadError = !1);
                          tR = null;
                        });
                    },
                    getItemAt: function (e) {
                      return e >= 0 && void 0 !== tD[e] && tD[e];
                    },
                    allowProgressiveImg: function () {
                      return (
                        r.forceProgressiveLoading ||
                        !E ||
                        r.mouseUsed ||
                        screen.width > 1200
                      );
                    },
                    setContent: function (e, t) {
                      r.loop && (t = eb(t));
                      var n = a.getItemAt(e.index);
                      n && (n.container = null);
                      var i,
                        s = a.getItemAt(t);
                      if (s) {
                        eI("gettingData", t, s), (e.index = t), (e.item = s);
                        var u = (s.container = o.createEl("pswp__zoom-wrap"));
                        if (
                          (!s.src &&
                            s.html &&
                            (s.html.tagName
                              ? u.appendChild(s.html)
                              : (u.innerHTML = s.html)),
                          t1(s),
                          tZ(s, ep),
                          !s.src || s.loadError || s.loaded)
                        )
                          s.src &&
                            !s.loadError &&
                            (((i = o.createEl(
                              "pswp__img",
                              "img"
                            )).style.opacity = 1),
                            (i.src = s.src),
                            t8(s, i),
                            tL(0, s, u, i));
                        else {
                          if (
                            ((s.loadComplete = function (n) {
                              if (l) {
                                if (e && e.index === t) {
                                  if (t1(n, !0))
                                    return (
                                      (n.loadComplete = n.img = null),
                                      tZ(n, ep),
                                      eE(n),
                                      void (
                                        e.index === c && a.updateCurrZoomItem()
                                      )
                                    );
                                  n.imageAppended
                                    ? !tO &&
                                      n.placeholder &&
                                      ((n.placeholder.style.display = "none"),
                                      (n.placeholder = null))
                                    : F.transform && (en || tO)
                                    ? tR.push({
                                        item: n,
                                        baseDiv: u,
                                        img: n.img,
                                        index: t,
                                        holder: e,
                                        clearPlaceholder: !0,
                                      })
                                    : tL(0, n, u, n.img, 0, !0);
                                }
                                (n.loadComplete = null),
                                  (n.img = null),
                                  eI("imageLoadComplete", t, n);
                              }
                            }),
                            o.features.transform)
                          ) {
                            var d = "pswp__img pswp__img--placeholder";
                            d += s.msrc ? "" : " pswp__img--placeholder--blank";
                            var p = o.createEl(d, s.msrc ? "img" : "");
                            s.msrc && (p.src = s.msrc),
                              t8(s, p),
                              u.appendChild(p),
                              (s.placeholder = p);
                          }
                          s.loading || tF(s),
                            a.allowProgressiveImg() &&
                              (!tS && F.transform
                                ? tR.push({
                                    item: s,
                                    baseDiv: u,
                                    img: s.img,
                                    index: t,
                                    holder: e,
                                  })
                                : tL(0, s, u, s.img, 0, !0));
                        }
                        tS || t !== c
                          ? eE(s)
                          : ((et = u.style), tk(s, i || s.img)),
                          (e.el.innerHTML = ""),
                          e.el.appendChild(u);
                      } else e.el.innerHTML = "";
                    },
                    cleanSlide: function (e) {
                      e.img && (e.img.onload = e.img.onerror = null),
                        (e.loaded = e.loading = e.img = e.imageAppended = !1);
                    },
                  },
                });
                var tz,
                  tM,
                  tN = {},
                  tU = function (e, t, n) {
                    var i = document.createEvent("CustomEvent"),
                      o = {
                        origEvent: e,
                        target: e.target,
                        releasePoint: t,
                        pointerType: n || "touch",
                      };
                    i.initCustomEvent("pswpTap", !0, !0, o),
                      e.target.dispatchEvent(i);
                  };
                e_("Tap", {
                  publicMethods: {
                    initTap: function () {
                      eC("firstTouchStart", a.onTapStart),
                        eC("touchRelease", a.onTapRelease),
                        eC("destroy", function () {
                          (tN = {}), (tz = null);
                        });
                    },
                    onTapStart: function (e) {
                      e.length > 1 && (clearTimeout(tz), (tz = null));
                    },
                    onTapRelease: function (e, t) {
                      var n, i;
                      if (t && !V && !G && !eH) {
                        var a = t;
                        if (
                          tz &&
                          (clearTimeout(tz),
                          (tz = null),
                          (n = a),
                          (i = tN),
                          25 > Math.abs(n.x - i.x) && 25 > Math.abs(n.y - i.y))
                        )
                          return void eI("doubleTap", a);
                        if ("mouse" === t.type) return void tU(e, t, "mouse");
                        if (
                          "BUTTON" === e.target.tagName.toUpperCase() ||
                          o.hasClass(e.target, "pswp__single-tap")
                        )
                          return void tU(e, t);
                        eT(tN, a),
                          (tz = setTimeout(function () {
                            tU(e, t), (tz = null);
                          }, 300));
                      }
                    },
                  },
                }),
                  e_("DesktopZoom", {
                    publicMethods: {
                      initDesktopZoom: function () {
                        Z ||
                          (E
                            ? eC("mouseUsed", function () {
                                a.setupDesktopZoom();
                              })
                            : a.setupDesktopZoom(!0));
                      },
                      setupDesktopZoom: function (t) {
                        tM = {};
                        var n = "wheel mousewheel DOMMouseScroll";
                        eC("bindEvents", function () {
                          o.bind(e, n, a.handleMouseWheel);
                        }),
                          eC("unbindEvents", function () {
                            tM && o.unbind(e, n, a.handleMouseWheel);
                          }),
                          (a.mouseZoomedIn = !1);
                        var i,
                          r = function () {
                            a.mouseZoomedIn &&
                              (o.removeClass(e, "pswp--zoomed-in"),
                              (a.mouseZoomedIn = !1)),
                              y < 1
                                ? o.addClass(e, "pswp--zoom-allowed")
                                : o.removeClass(e, "pswp--zoom-allowed"),
                              l();
                          },
                          l = function () {
                            i && (o.removeClass(e, "pswp--dragging"), (i = !1));
                          };
                        eC("resize", r),
                          eC("afterChange", r),
                          eC("pointerDown", function () {
                            a.mouseZoomedIn &&
                              ((i = !0), o.addClass(e, "pswp--dragging"));
                          }),
                          eC("pointerUp", l),
                          t || r();
                      },
                      handleMouseWheel: function (e) {
                        if (y <= a.currItem.fitRatio)
                          return (
                            r.modal &&
                              (!r.closeOnScroll || eH || B
                                ? e.preventDefault()
                                : O &&
                                  Math.abs(e.deltaY) > 2 &&
                                  ((u = !0), a.close())),
                            !0
                          );
                        if ((e.stopPropagation(), (tM.x = 0), "deltaX" in e))
                          1 === e.deltaMode
                            ? ((tM.x = 18 * e.deltaX), (tM.y = 18 * e.deltaY))
                            : ((tM.x = e.deltaX), (tM.y = e.deltaY));
                        else if ("wheelDelta" in e)
                          e.wheelDeltaX && (tM.x = -0.16 * e.wheelDeltaX),
                            e.wheelDeltaY
                              ? (tM.y = -0.16 * e.wheelDeltaY)
                              : (tM.y = -0.16 * e.wheelDelta);
                        else {
                          if (!("detail" in e)) return;
                          tM.y = e.detail;
                        }
                        e1(y, !0);
                        var t = ed.x - tM.x,
                          n = ed.y - tM.y;
                        (r.modal ||
                          (t <= ee.min.x &&
                            t >= ee.max.x &&
                            n <= ee.min.y &&
                            n >= ee.max.y)) &&
                          e.preventDefault(),
                          a.panTo(t, n);
                      },
                      toggleDesktopZoom: function (t) {
                        t = t || { x: ep.x / 2 + em.x, y: ep.y / 2 + em.y };
                        var n = r.getDoubleTapZoom(!0, a.currItem),
                          i = y === n;
                        (a.mouseZoomedIn = !i),
                          a.zoomTo(i ? a.currItem.initialZoomLevel : n, t, 333),
                          o[(i ? "remove" : "add") + "Class"](
                            e,
                            "pswp--zoomed-in"
                          );
                      },
                    },
                  });
                var t3,
                  tH,
                  tY,
                  tW,
                  tB,
                  tG,
                  tX,
                  tV,
                  tK,
                  t4,
                  t2,
                  tq,
                  t5 = { history: !0, galleryUID: 1 },
                  tj = function () {
                    return t2.hash.substring(1);
                  },
                  t6 = function () {
                    t3 && clearTimeout(t3), tY && clearTimeout(tY);
                  },
                  t7 = function () {
                    var e = tj(),
                      t = {};
                    if (e.length < 5) return t;
                    var n,
                      i = e.split("&");
                    for (n = 0; n < i.length; n++)
                      if (i[n]) {
                        var o = i[n].split("=");
                        o.length < 2 || (t[o[0]] = o[1]);
                      }
                    if (r.galleryPIDs) {
                      var a = t.pid;
                      for (t.pid = 0, n = 0; n < tD.length; n++)
                        if (tD[n].pid === a) {
                          t.pid = n;
                          break;
                        }
                    } else t.pid = parseInt(t.pid, 10) - 1;
                    return t.pid < 0 && (t.pid = 0), t;
                  },
                  t9 = function () {
                    if ((tY && clearTimeout(tY), eH || B))
                      tY = setTimeout(t9, 500);
                    else {
                      tW ? clearTimeout(tH) : (tW = !0);
                      var e = c + 1,
                        t = tA(c);
                      t.hasOwnProperty("pid") && (e = t.pid);
                      var n = tX + "&gid=" + r.galleryUID + "&pid=" + e;
                      tV || (-1 === t2.hash.indexOf(n) && (t4 = !0));
                      var i = t2.href.split("#")[0] + "#" + n;
                      tq
                        ? "#" + n !== window.location.hash &&
                          history[tV ? "replaceState" : "pushState"](
                            "",
                            document.title,
                            i
                          )
                        : tV
                        ? t2.replace(i)
                        : (t2.hash = n),
                        (tV = !0),
                        (tH = setTimeout(function () {
                          tW = !1;
                        }, 60));
                    }
                  };
                e_("History", {
                  publicMethods: {
                    initHistory: function () {
                      if ((o.extend(r, t5, !0), r.history)) {
                        (t2 = window.location),
                          (t4 = !1),
                          (tK = !1),
                          (tV = !1),
                          (tX = tj()),
                          (tq = "pushState" in history),
                          tX.indexOf("gid=") > -1 &&
                            (tX = (tX = tX.split("&gid=")[0]).split(
                              "?gid="
                            )[0]),
                          eC("afterChange", a.updateURL),
                          eC("unbindEvents", function () {
                            o.unbind(window, "hashchange", a.onHashChange);
                          });
                        var e = function () {
                          (tG = !0),
                            tK ||
                              (t4
                                ? history.back()
                                : tX
                                ? (t2.hash = tX)
                                : tq
                                ? history.pushState(
                                    "",
                                    document.title,
                                    t2.pathname + t2.search
                                  )
                                : (t2.hash = "")),
                            t6();
                        };
                        eC("unbindEvents", function () {
                          u && e();
                        }),
                          eC("destroy", function () {
                            tG || e();
                          }),
                          eC("firstUpdate", function () {
                            c = t7().pid;
                          });
                        var t = tX.indexOf("pid=");
                        t > -1 &&
                          "&" === (tX = tX.substring(0, t)).slice(-1) &&
                          (tX = tX.slice(0, -1)),
                          setTimeout(function () {
                            l && o.bind(window, "hashchange", a.onHashChange);
                          }, 40);
                      }
                    },
                    onHashChange: function () {
                      if (tj() === tX) return (tK = !0), void a.close();
                      tW || ((tB = !0), a.goTo(t7().pid), (tB = !1));
                    },
                    updateURL: function () {
                      t6(), tB || (tV ? (t3 = setTimeout(t9, 800)) : t9());
                    },
                  },
                }),
                  o.extend(a, {
                    shout: eI,
                    listen: eC,
                    viewportSize: ep,
                    options: r,
                    isMainScrollAnimating: function () {
                      return en;
                    },
                    getZoomLevel: function () {
                      return y;
                    },
                    getCurrentIndex: function () {
                      return c;
                    },
                    isDragging: function () {
                      return B;
                    },
                    isZooming: function () {
                      return J;
                    },
                    setScrollOffset: function (e, t) {
                      (em.x = e), (L = em.y = t), eI("updateScrollOffset", em);
                    },
                    applyZoomPan: function (e, t, n, i) {
                      (ed.x = t), (ed.y = n), (y = e), eA(i);
                    },
                    init: function () {
                      if (!l && !s) {
                        (a.framework = o),
                          (a.template = e),
                          (a.bg = o.getChildByClass(e, "pswp__bg")),
                          (R = e.className),
                          (l = !0),
                          (k = (F = o.detectFeatures()).raf),
                          (P = F.caf),
                          (O = F.transform),
                          (Z = F.oldIE),
                          (a.scrollWrap = o.getChildByClass(
                            e,
                            "pswp__scroll-wrap"
                          )),
                          (a.container = o.getChildByClass(
                            a.scrollWrap,
                            "pswp__container"
                          )),
                          (d = a.container.style),
                          (a.itemHolders = b =
                            [
                              {
                                el: a.container.children[0],
                                wrap: 0,
                                index: -1,
                              },
                              {
                                el: a.container.children[1],
                                wrap: 0,
                                index: -1,
                              },
                              {
                                el: a.container.children[2],
                                wrap: 0,
                                index: -1,
                              },
                            ]),
                          (b[0].el.style.display = b[2].el.style.display =
                            "none"),
                          (function () {
                            if (O)
                              return (
                                (h =
                                  "translate" +
                                  (F.perspective && !E ? "3d(" : "(")),
                                void (v = F.perspective ? ", 0px)" : ")")
                              );
                            (O = "left"),
                              o.addClass(e, "pswp--ie"),
                              (ek = function (e, t) {
                                t.left = e + "px";
                              }),
                              (eE = function (e) {
                                var t = e.fitRatio > 1 ? 1 : e.fitRatio,
                                  n = e.container.style,
                                  i = t * e.w,
                                  o = t * e.h;
                                (n.width = i + "px"),
                                  (n.height = o + "px"),
                                  (n.left = e.initialPosition.x + "px"),
                                  (n.top = e.initialPosition.y + "px");
                              }),
                              (eA = function () {
                                if (et) {
                                  var e = et,
                                    t = a.currItem,
                                    n = t.fitRatio > 1 ? 1 : t.fitRatio,
                                    i = n * t.w,
                                    o = n * t.h;
                                  (e.width = i + "px"),
                                    (e.height = o + "px"),
                                    (e.left = ed.x + "px"),
                                    (e.top = ed.y + "px");
                                }
                              });
                          })(),
                          ($ = {
                            resize: a.updateSize,
                            orientationchange: function () {
                              clearTimeout(z),
                                (z = setTimeout(function () {
                                  ep.x !== a.scrollWrap.clientWidth &&
                                    a.updateSize();
                                }, 500));
                            },
                            scroll: eU,
                            keydown: eM,
                            click: eN,
                          });
                        var n,
                          i =
                            F.isOldIOSPhone ||
                            F.isOldAndroid ||
                            F.isMobileOpera;
                        for (
                          (F.animationName && F.transform && !i) ||
                            (r.showAnimationDuration = r.hideAnimationDuration =
                              0),
                            n = 0;
                          n < eh.length;
                          n++
                        )
                          a["init" + eh[n]]();
                        t && (a.ui = new t(a, o)).init(),
                          eI("firstUpdate"),
                          (c = c || r.index || 0),
                          (isNaN(c) || c < 0 || c >= tE()) && (c = 0),
                          (a.currItem = tA(c)),
                          (F.isOldIOSPhone || F.isOldAndroid) && (ex = !1),
                          e.setAttribute("aria-hidden", "false"),
                          r.modal &&
                            (ex
                              ? (e.style.position = "fixed")
                              : ((e.style.position = "absolute"),
                                (e.style.top = o.getScrollY() + "px"))),
                          void 0 === L &&
                            (eI("initialLayout"), (L = T = o.getScrollY()));
                        var u = "pswp--open ";
                        for (
                          r.mainClass && (u += r.mainClass + " "),
                            r.showHideOpacity &&
                              (u += "pswp--animate_opacity "),
                            u += E ? "pswp--touch" : "pswp--notouch",
                            u += F.animationName ? " pswp--css_animation" : "",
                            u += F.svg ? " pswp--svg" : "",
                            o.addClass(e, u),
                            a.updateSize(),
                            p = -1,
                            ey = null,
                            n = 0;
                          n < 3;
                          n++
                        )
                          ek((n + p) * e$.x, b[n].el.style);
                        Z || o.bind(a.scrollWrap, m, a),
                          eC("initialZoomInEnd", function () {
                            a.setContent(b[0], c - 1),
                              a.setContent(b[2], c + 1),
                              (b[0].el.style.display = b[2].el.style.display =
                                "block"),
                              r.focus && e.focus(),
                              o.bind(document, "keydown", a),
                              F.transform && o.bind(a.scrollWrap, "click", a),
                              r.mouseUsed || o.bind(document, "mousemove", eF),
                              o.bind(
                                window,
                                "resize scroll orientationchange",
                                a
                              ),
                              eI("bindEvents");
                          }),
                          a.setContent(b[1], c),
                          a.updateCurrItem(),
                          eI("afterInit"),
                          ex ||
                            (g = setInterval(function () {
                              eH ||
                                B ||
                                J ||
                                y !== a.currItem.initialZoomLevel ||
                                a.updateSize();
                            }, 1e3)),
                          o.addClass(e, "pswp--visible");
                      }
                    },
                    close: function () {
                      l &&
                        ((l = !1),
                        (s = !0),
                        eI("close"),
                        o.unbind(window, "resize scroll orientationchange", a),
                        o.unbind(window, "scroll", $.scroll),
                        o.unbind(document, "keydown", a),
                        o.unbind(document, "mousemove", eF),
                        F.transform && o.unbind(a.scrollWrap, "click", a),
                        B && o.unbind(window, f, a),
                        clearTimeout(z),
                        eI("unbindEvents"),
                        tk(a.currItem, null, !0, a.destroy));
                    },
                    destroy: function () {
                      eI("destroy"),
                        tI && clearTimeout(tI),
                        e.setAttribute("aria-hidden", "true"),
                        (e.className = R),
                        g && clearInterval(g),
                        o.unbind(a.scrollWrap, m, a),
                        o.unbind(window, "scroll", a),
                        ti(),
                        eB(),
                        (ew = null);
                    },
                    panTo: function (e, t, n) {
                      n ||
                        (e > ee.min.x
                          ? (e = ee.min.x)
                          : e < ee.max.x && (e = ee.max.x),
                        t > ee.min.y
                          ? (t = ee.min.y)
                          : t < ee.max.y && (t = ee.max.y)),
                        (ed.x = e),
                        (ed.y = t),
                        eA();
                    },
                    handleEvent: function (e) {
                      $[(e = e || window.event).type] && $[e.type](e);
                    },
                    goTo: function (e) {
                      var t = (e = eb(e)) - c;
                      (ey = t),
                        (c = e),
                        (a.currItem = tA(c)),
                        (ef -= t),
                        eP(e$.x * ef),
                        eB(),
                        (en = !1),
                        a.updateCurrItem();
                    },
                    next: function () {
                      a.goTo(c + 1);
                    },
                    prev: function () {
                      a.goTo(c - 1);
                    },
                    updateCurrZoomItem: function (e) {
                      if (
                        (e && eI("beforeChange", 0), b[1].el.children.length)
                      ) {
                        var t = b[1].el.children[0];
                        et = o.hasClass(t, "pswp__zoom-wrap") ? t.style : null;
                      } else et = null;
                      (ee = a.currItem.bounds),
                        (x = y = a.currItem.initialZoomLevel),
                        (ed.x = ee.center.x),
                        (ed.y = ee.center.y),
                        e && eI("afterChange");
                    },
                    invalidateCurrItems: function () {
                      _ = !0;
                      for (var e = 0; e < 3; e++)
                        b[e].item && (b[e].item.needsUpdate = !0);
                    },
                    updateCurrItem: function (e) {
                      if (0 !== ey) {
                        var t,
                          n = Math.abs(ey);
                        if (!(e && n < 2)) {
                          (a.currItem = tA(c)),
                            (eg = !1),
                            eI("beforeChange", ey),
                            n >= 3 && ((p += ey + (ey > 0 ? -3 : 3)), (n = 3));
                          for (var i = 0; i < n; i++)
                            ey > 0
                              ? ((t = b.shift()),
                                (b[2] = t),
                                ek((++p + 2) * e$.x, t.el.style),
                                a.setContent(t, c - n + i + 1 + 1))
                              : ((t = b.pop()),
                                b.unshift(t),
                                ek(--p * e$.x, t.el.style),
                                a.setContent(t, c + n - i - 1 - 1));
                          if (et && 1 === Math.abs(ey)) {
                            var o = tA(w);
                            o.initialZoomLevel !== y &&
                              (tZ(o, ep), t8(o), eE(o));
                          }
                          (ey = 0),
                            a.updateCurrZoomItem(),
                            (w = c),
                            eI("afterChange");
                        }
                      }
                    },
                    updateSize: function (t) {
                      if (!ex && r.modal) {
                        var n = o.getScrollY();
                        if (
                          (L !== n && ((e.style.top = n + "px"), (L = n)),
                          !t &&
                            ev.x === window.innerWidth &&
                            ev.y === window.innerHeight)
                        )
                          return;
                        (ev.x = window.innerWidth),
                          (ev.y = window.innerHeight),
                          (e.style.height = ev.y + "px");
                      }
                      if (
                        ((ep.x = a.scrollWrap.clientWidth),
                        (ep.y = a.scrollWrap.clientHeight),
                        eU(),
                        (e$.x = ep.x + Math.round(ep.x * r.spacing)),
                        (e$.y = ep.y),
                        eP(e$.x * ef),
                        eI("beforeResize"),
                        void 0 !== p)
                      ) {
                        for (var i, l, s, u = 0; u < 3; u++)
                          (i = b[u]),
                            ek((u + p) * e$.x, i.el.style),
                            (s = c + u - 1),
                            r.loop && tE() > 2 && (s = eb(s)),
                            (l = tA(s)) && (_ || l.needsUpdate || !l.bounds)
                              ? (a.cleanSlide(l),
                                a.setContent(i, s),
                                1 === u &&
                                  ((a.currItem = l), a.updateCurrZoomItem(!0)),
                                (l.needsUpdate = !1))
                              : -1 === i.index && s >= 0 && a.setContent(i, s),
                            l && l.container && (tZ(l, ep), t8(l), eE(l));
                        _ = !1;
                      }
                      (x = y = a.currItem.initialZoomLevel),
                        (ee = a.currItem.bounds) &&
                          ((ed.x = ee.center.x), (ed.y = ee.center.y), eA(!0)),
                        eI("resize");
                    },
                    zoomTo: function (e, t, n, i, a) {
                      t &&
                        ((x = y),
                        (te.x = Math.abs(t.x) - ed.x),
                        (te.y = Math.abs(t.y) - ed.y),
                        eT(ec, ed));
                      var r = e1(e, !1),
                        l = {};
                      ez("x", r, l, e), ez("y", r, l, e);
                      var s = y,
                        u = ed.x,
                        c = ed.y;
                      eZ(l);
                      var d = function (t) {
                        1 === t
                          ? ((y = e), (ed.x = l.x), (ed.y = l.y))
                          : ((y = (e - s) * t + s),
                            (ed.x = (l.x - u) * t + u),
                            (ed.y = (l.y - c) * t + c)),
                          a && a(t),
                          eA(1 === t);
                      };
                      n
                        ? eG(
                            "customZoomTo",
                            0,
                            1,
                            n,
                            i || o.easing.sine.inOut,
                            d
                          )
                        : d(1);
                    },
                  });
              };
            }),
            "function" == typeof define && define.amd
              ? define(i)
              : "object" == typeof e
              ? (t.exports = i())
              : (n.PhotoSwipe = i());
        },
      }),
      function () {
        return (
          t || (0, e[Object.keys(e)[0]])((t = { exports: {} }).exports, t),
          t.exports
        );
      })()),
      ((e, t, n) => {
        if ((t && "object" == typeof t) || "function" == typeof t)
          for (let i of s(t))
            c.call(e, i) ||
              "default" === i ||
              r(e, i, {
                get: () => t[i],
                enumerable: !(n = l(t, i)) || n.enumerable,
              });
        return e;
      })(
        ((i = r(
          null != n ? a(u(n)) : {},
          "default",
          n && n.__esModule && "default" in n
            ? { get: () => n.default, enumerable: !0 }
            : { value: n, enumerable: !0 }
        )),
        r(i, "__esModule", { value: !0 })),
        n
      ));
  window.ThemePhotoSwipe = d.default;
})();
